import CityPageTemplate from "../city-template/CityPageTemplate";
import { appletonConfig } from "./data";

export default function AppletonPage() {
  return <CityPageTemplate config={appletonConfig} />;
}